export default __webpack_public_path__ + "static/media/pl_nurse1.6ecfa311.png";